module.exports = __webpack_public_path__ + "static/media/TCI.Privacy.Policy.67caa3d4.docx";